<template>
  <b-row>
    <b-col
      md="4"
      lg="4"
      offset-lg="3"
    >
      <b-card
        no-body
        class="card-payment"
      >
        <b-overlay
          id="overlay-background"
          :show="loader"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="sm"
          spinner-variant="primary"
          spinner-medium
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <validation-observer
                ref="settingsform"
                tag="form"
              >
                <b-row>
                  <b-col sm="12">

                    <b-form-group
                      :label="$t('DEBTIA_DEFAULT_KEY')"
                      label-for="default-key"
                    >
                      <v-select
                        v-model="selected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="settingKeysOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        input-id="login-status"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'default_interest_rate'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Interest Rate"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_INTEREST_RATE')"
                        label-for="interest_rate"
                      >
                        <b-form-input
                          id="interest_rate"
                          v-model="settingsData.value"
                          type="number"
                          :placeholder="$t('DEBTIA_DEFAULT_INTEREST_RATE')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'default_vat_rate'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Interest Rate"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VAT_RATE')"
                        label-for="vat_rate"
                      >
                        <b-form-input
                          id="interest_rate"
                          v-model="settingsData.value"
                          type="number"
                          :placeholder="$t('DEBTIA_DEFAULT_VAT_RATE')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      block
                      variant="primary"
                      @click="postSettingValues"
                    >
                      Save
                    </b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-form>
          <!--/ form -->
          </b-card-body>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BFormInput, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BOverlay,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected: 'default_interest_rate',
      settingKeysOptions: [
        { label: 'Interest Rate', value: 'default_interest_rate' },
        { label: 'Vat Rate', value: 'default_vat_rate' },
      ],
      settingsData: {
        key: '',
        value: '',
      },
      loader: false,
      required,
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(newValue) {
        this.getSettingValues(newValue)
      },
    },
  },
  created() {
    this.getSettingValues('default_interest_rate')
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    getSettingValues(selected) {
      this.loader = true
      axios.get('default-settings/get', { params: { key: selected } }).then(response => {
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.settingsData.key = 'default_interest_rate'
          this.settingsData.value = ''
        } else {
          this.settingsData.key = settingDetails.key
          this.settingsData.value = settingDetails.value
        }
        this.loader = false
      })
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.settingsData.key = this.selected
            this.loader = true
            axios.post('default-settings/save', { ...this.settingsData }).then(response => {
              this.loader = false
              console.log(response)
              this.makeSuccessToast()
              resolve(true)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
